module.exports = __webpack_public_path__ + "static/media/nk_logo_home.b5412164.png";